export const tr = {
    'be-sure-no-error': 'Böyle bir sayfa yok',
    info: 'Bu durum, yazım hatası veya doğru olmayan klavye düzeninin kullanımı nedeniyle ortaya çıkmış olabilir'
};
